/* eslint-disable */
import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import Icon from "@mui/material/Icon";
// @mui/icons-material
import Build from "@mui/icons-material/Build";
import Subject from "@mui/icons-material/Subject";
import FormatPaint from "@mui/icons-material/FormatPaint";
import Code from "@mui/icons-material/Code";
import Dashboard from "@mui/icons-material/Dashboard";
import Timeline from "@mui/icons-material/Timeline";
import Group from "@mui/icons-material/Group";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Badge from "components/Badge/Badge.js";

import projectsStyle from "styles/jss/nextjs-material-kit-pro/pages/sectionsSections/projectsStyle.js";

const useStyles = makeStyles(projectsStyle);

export default function SectionProjects({ ...rest }) {
  const classes = useStyles();
  return (
    <div className="cd-section" {...rest}>
      
      {/* Project 2 START */}
      <div className={classes.projects}>
        <div className={classes.container}>


          <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/streamlit-and-google-analytics-data"
                >
                  
                  <CardHeader image plain>
                    <img
                      src={
                        "/img/sections/services/streamlit/streamlit_and_ga.png"
                      }
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/217/original/opt_mk_nextjs_thumbnail.jpg?1525851474')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/streamlit-and-google-analytics-data"
                  >
                    <h4 className={classes.cardTitle}>
                    Streamlit & David Jones: Google Analytics Data
                    </h4>
                  </a>
                  <h6 className={classes.description}>Obtaining insights from Google Analytics data with Streamlit </h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    In this case study we showcase a few Streamlit applications that we made for David Jones in order to help them understand their Google Analytics data in a more meaningful way.
                  </p>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/streamlit-and-business-performance"
                  
                >
                  <CardHeader image plain>
                    <img
                      src="/img/sections/services/streamlit/streamlit_login.png"
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/66/thumb/opt_lbp_react_thumbnail.jpg?1509466309')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/streamlit-and-business-performance"
                    
                  >
                    <h4 className={classes.cardTitle}>
                    Streamlit & Bizcap: Business Performance Dashboard
                    </h4>
                  </a>
                  <h6 className={classes.description}>New Way of Making Dashboards</h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    In this study case we showcase a detailed and fast Streamlit application designed for Bizcap's business performance monitoring. 

                  </p>
                </CardBody>
              </Card>
            </GridItem>


            <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/bizcap"
                >
                  
                  <CardHeader image plain>
                    <img
                      src={
                        "/img/sections/bizcap-wordpress.jpg"
                      }
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/217/original/opt_mk_nextjs_thumbnail.jpg?1525851474')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/bizcap"
                  >
                    <h4 className={classes.cardTitle}>
                    Client 1: Bizcap
                    </h4>
                  </a>
                  <h6 className={classes.description}>Website Redesign & Marketing Ramp-up </h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    Bizcap is Australia's most open minded lender for business loans. They have redeveloped their website completely - with a focus on design and SEO and have ramped up their digital marketing across Facebook, Linkedin and Adowrds. Find out more.
                  </p>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/david-jones-and-country-road-group"
                >
                  
                  <CardHeader image plain>
                    <img
                      src={
                        "/img/sections/djs-gtm.jpg"
                      }
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/217/original/opt_mk_nextjs_thumbnail.jpg?1525851474')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/david-jones-and-country-road-group"
                  >
                    <h4 className={classes.cardTitle}>
                    Client 2: David Jones and Country Road Group
                    </h4>
                  </a>
                  <h6 className={classes.description}>Analytics Helpdesk for a Major Retail Group </h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    The retail industry is extremely competitive - especially online shopping.
                    Here at Tribalism, we work with David Jones and Country Road Group stores to maintain and enrich their digital presence.
                  </p>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/quallogi"
                  
                >
                  <CardHeader image plain>
                    <img
                      src="/img/sections/Quallogi-FB.jpg"
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/66/thumb/opt_lbp_react_thumbnail.jpg?1509466309')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/quallogi"
                    
                  >
                    <h4 className={classes.cardTitle}>
                    Client 3: Quallogi
                    </h4>
                  </a>
                  <h6 className={classes.description}>New App Launch & Website</h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    Q by Quallogi is the only electronic work diary (EWD) app for truckies, availble on both iOS and Android. We have helped luanch the app on Facebook and Linkedin and rebuilt their website. FInd out more.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            
            

            <GridItem xs={12} sm={6} md={6}>
              <Card plain className={classes.card2}>
                <a
                  href="/our-work/afl"
                >
                  
                  <CardHeader image plain>
                    <img
                      src={
                        "/img/sections/afl/afl-home3.jpg"
                      }
                      alt="..."
                    />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage:
                          "url('https://s3.amazonaws.com/creativetim_bucket/products/217/original/opt_mk_nextjs_thumbnail.jpg?1525851474')",
                        opacity: "1",
                      }}
                    />
                  </CardHeader>
                </a>
                <CardBody plain>
                  <a
                    href="/our-work/david-jones-and-country-road-group"
                  >
                    <h4 className={classes.cardTitle}>
                    Client 4: AFL NSW/ACT
                    </h4>
                  </a>
                  <h6 className={classes.description}>Implementing a Dat Capture and Storage service for Field Officers </h6>
                  <p
                    className={classes.description + " " + classes.marginTop20}
                  >
                    The AFL dedicates a huge qmount of resources to growing the game in non-traditional states such as NSW and the ACT. 
                    As part of that it needs to manage its data welll, in a way in whcih all teams can access it, but data priacy is protected.
                  </p>
                </CardBody>
              </Card>
            </GridItem>



          </GridContainer>
        </div>
      </div>
      {/* Project 2 END */}
      
    </div>
  );
}
